<template>
    	<li class="m-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-center 	m-dropdown--mobile-full-width" m-dropdown-toggle="click"
										 m-dropdown-persistent="1">
											<a href="#" class="m-nav__link m-dropdown__toggle" id="m_topbar_notification_icon">
												<span v-show="items.length" class="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span>
												<span class="m-nav__link-icon"><i class="flaticon-alarm"></i></span>
											</a>
											<div class="m-dropdown__wrapper">
												<span class="m-dropdown__arrow m-dropdown__arrow--center"></span>
												<div class="m-dropdown__inner">
													<div class="m-dropdown__header m--align-center" style="background-color:#3a77fe;">
														<span class="m-dropdown__header-title">{{items.length}} Bildirim</span>
													</div>
													<div class="m-dropdown__body">
														<div class="m-dropdown__content">
															<div class="tab-content">
																<div class="tab-pane active" id="topbar_notifications_notifications" role="tabpanel">
																	<div class="m-scrollable" data-scrollable="true" data-height="250" data-mobile-height="200">
																	
																			<div v-for="item in items" v-bind:key="item.id" class="m-list-timeline__items">
																				<div class="m-list-timeline__item">
																					<span class="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
																					<span class="m-list-timeline__text"> 
																						 <a  :href="'#/'+ getLink(item)" title="View"> {{item.data}} </a> 
																						
																							</span>
																					<span class="m-list-timeline__time">{{getDateDiffs(item.createdDate)}}</span>
																				</div>
																			</div>
																			<div v-if="items && items.length"  class="m-list-timeline m-list-timeline--skin-light">
																		</div>
																		<div v-else  class="m-list-timeline m-list-timeline--skin-light">
																				<div class="m-list-timeline__item">
																					<span class="m-list-timeline__badge"></span>
																					<span class="m-list-timeline__text">Yaşasın Bekleyen Mesajınız yok</span>
																					<span class="m-list-timeline__time"></span>
																				</div>
																		</div>

																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</li>
</template>

<script>
import {_getMyNotifications,_delete,_setRead,_getTypeUrlStrings} from '../services/NotificationService'
import * as moment from 'moment/moment'
import 'moment/locale/tr';
export default {
  data() {
    return {
      items: []
    };
  },
  created() {
      this.getAll();
  },
  methods: {
	  getDateDiffs:function(baseDate){
		return moment( baseDate).fromNow();
	  },
    getAll: function() {
    // let loader=this.$loading.show();
      _getMyNotifications().then(response=> {
                //  loader.hide();
                 if(response.data.success)
        this.items = response.data.data.items;
      });
     
    },
    deleteon:function(dialog,item){
        _delete(item.id).then(response=>{
          if(response.data.success)
          this.getAll()
        });
              dialog.close();
    },
        setRead:function(item){
        _setRead(item).then(response=>{
          if(response.data.success)
          this.getAll()
        });
	},
	getLink: function(item)
	{
		if (item.DataType != null && item.DataType != 0)
			return    _getTypeUrlStrings(item.DataType).url + '/' + item.referenceId ;
		else
		 	return "Notifications";
	}
  }
};
</script>